'use client';
import { CockpitBoardView } from '../../components/cockpit/board';
import { useSession } from '../../lib/session';
const readers = ['COCKPIT_VIEWER', 'ORGANIZATION_ADMIN', 'PROFILE_CASE_REVIEWER'];
export default function CockpitPage() {
  const session = useSession();
  if (!readers.some(r => session.hasRole(r))) return <main className="cockpit" role="main"><h1>领导驾驶舱</h1><p role="status">当前职责无法查看驾驶舱，请核对我的授权。</p><a href="/authority">查看我的授权</a></main>;
  return <CockpitBoardView />;
}
